module.exports = __webpack_public_path__ + "static/media/icono-flecha-blanca.b522169a.svg";